// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"PreviewModal_imgWrap-3fD_t"};